'use strict'
import $ from 'jquery'
import { resetPassword } from '../api/checkout'
import alert from '../ui/alert'
import { showErrorMessage } from '../util/form'
import util from '../util'
import { showPasswordResetStep } from '../club/user-login';

export default () => {
	const $container = $('.club-login')
	if (!$container.length) return

	const $resetPassword = $container.find('.reset-password')
	const $loginForm = $container.find('.login-form')
	const showAlert = alert($container)

	const showPasswordResetForm = () => {
		const email = $loginForm.find('input[name="username"]').val().trim()
		if (email) {
			$resetPassword.find('input#reset-password-email').val(email)
		}
		$resetPassword.removeClass('hidden')
		$loginForm.addClass('hidden')
	}

	const showLoginForm = () => {
		$resetPassword.addClass('hidden')
		$loginForm.removeClass('hidden')
	}

	const setContainerHeight = function () {
		if (document.body.classList.contains('club-login-page')) {
			const contentHeight = $('.is-shown').height();
			$('.left-column .slot-container .slot-height').css('height', contentHeight);
		}
	}

	$container.find('.reset-password-link').click(e => {
		e.preventDefault()
		showPasswordResetForm();
		setContainerHeight();
	})

	$('.back-to-request-otp').click(e => {
		e.preventDefault();
		showPasswordResetStep(1);
	})

	$resetPassword.on('click', '.back', e => {
		e.preventDefault();
		showLoginForm();
		setContainerHeight();
	})

	$resetPassword.on('submit', '.reset-password-form', e => {
		e.preventDefault();

		const $emailInput = $resetPassword.find('input#reset-password-email')
		const email1 = $emailInput.val()

		// temporary fix before updated site (with masterpass) is published
		const $oldEmailInput = $resetPassword.find('input#email');
		const email2 = $oldEmailInput.val();

		const email = email1 ? email1 : email2;

		if (!email.trim()) {
			return showErrorMessage({
				$input: $emailInput,
				message: 'Syötä sähköpostiosoite',
				persistent: true
			})
		}

		const $loader = util.addFormLoader($resetPassword.find('input[type="submit"]'))
		const source = $resetPassword.find('input[name="source"]').val();

		return resetPassword(email, { source })
			.tap(({result, message}) => {
				showAlert({ message, type: 'success', persistent: true })
				showLoginForm()
			})
			.finally(() => $loader.done())
	})

}
